// import React from 'react';
// import ReactDOM from 'react-dom';
// import App from './App';

// ReactDOM.render(<App/>, document.getElementById('root'));




import ReactDOM from 'react-dom';
import ApolloProvider from './ApolloProviders';


ReactDOM.render(ApolloProvider, document.getElementById('root'));

